import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DescriptionSharpIcon from '@mui/icons-material/DescriptionSharp';
import HomeIcon from '@mui/icons-material/Home';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import MapSharpIcon from '@mui/icons-material/MapSharp';
import MenuIcon from '@mui/icons-material/Menu';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import { Box, Fab, IconButton, Popover, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import rehypeHighlight from "rehype-highlight";
import rehypeSlug from "rehype-slug-custom-id";
import remarkGfm from "remark-gfm";
import remarkUnwrapImages from 'remark-unwrap-images';
import Menu from "./Components/Menu";
import MenuBase from "./Components/MenuBase";
import MenuButton from "./Components/MenuButton";
import Topbar from "./Components/Topbar";
import Data_model_description from "./Contents/Data_model_description.md";
import MenuMarkdown from "./Contents/MenuMarkdown.md";
import content from "./Contents/sections/content.md";
import index from "./Contents/sections/index.md";


export default function MainPage() {

    const [contentText, setContentText] = useState("")
    const [menu, setMenu] = useState("")

    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    useEffect(() => {
        fetch(content)
            .then((res) => res.text())
            .then((text) => setContentText(text));
        fetch(index)
            .then(res => res.text())
            .then(text => setMenu(text))
    }, []);

    return (
        <Box
            className="app"
            display='flex'
            flexDirection='column'
            sx={{
                height: '100vh',
            }}
        >
            <Topbar title={"BMSnet Documentation"}
                logo=
                {
                    <IconButton onClick={handleClick} >
                        <MenuIcon sx={{ color: "#ffffff" }} />
                    </IconButton>
                }
                color={'#b00000'}
            />
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose} 
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Menu width='200px' sx={{ marginRight: '0px' }}>
                    <MenuButton
                        text="Forside"
                        onclick={() => {
                            window.location.replace(window.location.origin);
                        }}
                        icon={<HomeIcon color='primary' />}
                    />
                    <MenuButton
                        text="Dashboard"
                        onclick={() => {
                            window.location.replace("https://dashboard.cas.dtu.dk/");
                        }}
                        icon={<DashboardIcon color='primary' />}
                    />
                    <MenuButton
                        text="Alarmer"
                        onclick={() => {
                            window.location.replace("https://bmsnetalarm.cas.dtu.dk/");
                        }}
                        icon={<AccessAlarmIcon color='primary' />}
                    />
                    <MenuButton
                        text="Diagrammer"
                        onclick={() => {
                            window.location.replace(window.location.origin + "/view/");
                        }}
                        icon={<ShowChartIcon color='primary' />}
                    />
                    <MenuButton
                        text="Kort"
                        onclick={() => {
                            window.location.replace(window.location.origin + "/maps/");
                        }}
                        icon={<MapSharpIcon color='primary' />}
                    />
                    <MenuButton
                        text="Administration"
                        onclick={() => {
                            window.location.replace(window.location.origin + "/admin/");
                        }}
                        icon={<AdminPanelSettingsIcon color='primary' />}
                    />
                    <MenuButton
                        text="Dokumentation"
                        onclick={() => {
                            window.location.replace(window.location.origin + "/documentation/");
                        }}
                        icon={<DescriptionSharpIcon color='primary' />}
                    />
                </Menu>
            </Popover>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    flexGrow: 1,
                    overflow: 'hidden',
                }}>
                <MenuBase
                    boxShadow={0}
                    footer={(
                        <Typography
                            sx={{
                                fontSize: 12,
                                marginLeft: 1,
                                color: "#999999"
                            }}
                        >
                            BMSnet Documentation
                        </Typography>
                    )}
                >
                    <ReactMarkdown
                        children={menu}
                        className="sideMenu"
                    />
                </MenuBase>

                <Box sx={{
                    display: "flex",
                    flexDirection: "row",
                    flexGrow: 1,
                    overflow: 'auto',
                }}>
                    <Box
                        className='content'
                        pl={2}
                        pr={2}
                        sx={{
                            display: 'flex',
                            flexDirection: "column",
                            flexGrow: 1,
                            overflow: 'auto',
                        }}>
                        <ReactMarkdown
                            children={contentText}
                            remarkPlugins={[remarkGfm, remarkUnwrapImages]}
                            rehypePlugins={[
                                rehypeHighlight,
                                rehypeSlug,
                            ]} />
                    </Box>
                    <Box
                        position='fixed'
                        bottom='16px'
                        right='28px'
                        zIndex={10}
                    >
                        <Tooltip title="Scroll to top" placement='left'>
                            <Fab
                                color="primary"
                                href="#bmsnet-cloud-overview"
                                size='small'
                            >
                                <KeyboardArrowUpIcon />
                            </Fab>
                        </Tooltip>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}